import React from "react";
import {connect} from "react-redux";
import locale from "../../locale";
import onBannerClick from "../../actions/onBannerClick";

function Partner(props)
{
	const {logoUrl, link, trackingKey, event, size} = props;

	const onClick = () => {
		if (!trackingKey) {
			return;
		}

		onBannerClick(event.id, trackingKey);
	};

	return (
		<div className={`partner-logo partner-logo-size-${size || '1x1'}`}>
			{link && link !== '#' ?
				<a href={link} target="_blank"
				   onClick={onClick}
				   title={locale.getProperty(props, 'title')}
				   style={{backgroundImage: `url(${logoUrl})`}}
				/>
				:
				<div
					onClick={onClick}
					title={locale.getProperty(props, 'title')}
					style={{backgroundImage: `url(${logoUrl})`}}
				/>
			}
		</div>
	);
}

function PartnerRate(props)
{
	const {brand} = props;
	const title = locale.getProperty(props, 'title');

	return (
		<article>
			{title ? <h2>{title}</h2> : null}
			<section className="partner-logos">
				{brand.map((partner, index) => <Partner {...partner} key={`partner_${index}`} />)}
			</section>
		</article>
	);
}

function Partners({partners, event}) {
	if (partners[0].brand) {
		return (
			<div>
				{partners.map((partnerRate, index) => (
					<PartnerRate {...partnerRate} key={`partnerRate_${index}`} />
				))}
			</div>
		);
	}

	return (
		<div>
			{partners.map((partner, index) => (
				<Partner {...partner} key={`partner_${index}`} event={event} />
			))}
		</div>
	);
}

class LayoutPartners extends React.Component
{
	constructor(props) {
		super(props);

		this.state = {
			partners: [{
				titleRu: 'Платиновые спонсоры',
				titleEn: 'Platinum Sponsors',
				brand: [{
					nameRu: 'Кингстон',
					nameEn: 'Kingston',
					link: '#',
					logo: 'https://upload.wikimedia.org/wikipedia/ru/5/5c/Kingston-logo-2.jpg',
				}],
			},{
				titleRu: 'Золотые спонсоры',
				titleEn: 'Gold Sponsors',
				brand: [{
					name: 'Kingston',
					link: '#',
					logo: 'https://upload.wikimedia.org/wikipedia/ru/5/5c/Kingston-logo-2.jpg',
				},{
					name: 'Kingston',
					link: '#',
					logo: 'https://upload.wikimedia.org/wikipedia/ru/5/5c/Kingston-logo-2.jpg',
				}],
			},{
				titleRu: 'Серебрянные спонсоры',
				titleEn: 'Silver Sponsors',
				brand: [{
					name: 'Kingston',
					link: '#',
					logo: 'https://upload.wikimedia.org/wikipedia/ru/5/5c/Kingston-logo-2.jpg',
				},{
					name: 'Kingston',
					link: '#',
					logo: 'https://upload.wikimedia.org/wikipedia/ru/5/5c/Kingston-logo-2.jpg',
				},{
					name: 'Kingston',
					link: '#',
					logo: 'https://upload.wikimedia.org/wikipedia/ru/5/5c/Kingston-logo-2.jpg',
				}],
			},{
				titleRu: 'Bronze Sponsors',
				titleEn: 'Brown sponsors',
				brand: [{
					name: 'Kingston',
					link: '#',
					logo: 'https://upload.wikimedia.org/wikipedia/ru/5/5c/Kingston-logo-2.jpg',
				},{
					name: 'Kingston',
					link: '#',
					logo: 'https://upload.wikimedia.org/wikipedia/ru/5/5c/Kingston-logo-2.jpg',
				},{
					name: 'Kingston',
					link: '#',
					logo: 'https://upload.wikimedia.org/wikipedia/ru/5/5c/Kingston-logo-2.jpg',
				},{
					name: 'Kingston',
					link: '#',
					logo: 'https://upload.wikimedia.org/wikipedia/ru/5/5c/Kingston-logo-2.jpg',
				}],
			}],
		};
	}

	render()
	{
		const {settings, event} = this.props;

		if (!settings) {
			return null;
		}

		const {partners} = settings;

		if (!(partners instanceof Array) || partners.length <= 0) {
			return null;
		}

		return (
			<aside className="section-partners" id="partners">
				<h1>{locale.getProperty(settings, 'title') || locale.get('layer-partners-title')}</h1>
				<div className="landing-nav-section-text">
					<section className="partner-logos">
						<Partners partners={partners} event={event} />
					</section>
				</div>
			</aside>
		);
	}
}

const mapStateToProps = (store) => ({
	event: store.event,
});

export default connect(mapStateToProps)(LayoutPartners);
